export const API_PREFIX = '/api';
export const STUDIO_PREFIX = `${API_PREFIX}/studio`; // 组织管理
export const ADMIN_PREFIX = `${API_PREFIX}/admin`; // 管理员
export const MESSAGE_PREFIX = `${API_PREFIX}/message`; // 消息
export const MESSAGE_CREATE_PREFIX = `${ADMIN_PREFIX}/message`; // 创建消息
export const SERVICE_PREFIX = `${API_PREFIX}/service`; // 服务
export const APP_CONFIG_PREFIX = `${API_PREFIX}/app-config`; // app配置
export const PERMISSION_PREFIX = `${API_PREFIX}/rbac`; // 权限管理
export const COMPANY_PREFIX = `${API_PREFIX}/company`; // 企业认证
export const ADMIN_COMPANY_PREFIX = `${ADMIN_PREFIX}/company`; // 企业认证管理端
export const ADMIN_NOTICE_PREFIX = `${ADMIN_PREFIX}/notice-system`; // 业务通知管理端

// 代理api
export const PERMISSION_PROXY_PREFIX = `${API_PREFIX}/rbac/proxy/ingame.OpenApiSrv`; // 权限代理的api
export const ADMIN_PERMISSION_PROXY_PREFIX = `${ADMIN_PREFIX}/rbac/proxy/ingame.OpenApiSrv`; // admin权限代理的api
export const TOKEN_PROXY_PREFIX = `${API_PREFIX}/user/proxy`; // accessToken代理的api
export const INGAME_CONSOLE_PROXY_PREFIX_GAME = `${API_PREFIX}/ingame-console/proxy/game`; // ingame console 代理api 游戏级别
export const INGAME_CONSOLE_PROXY_PREFIX = `${API_PREFIX}/ingame-console/proxy/env`; // ingame console 代理api 环境级别
export const INGAME_CONSOLE_AUDIT_PROXY_PREFIX = `${API_PREFIX}/ingame-console/proxy/audit-logs`; // 审计中心 代理api
export const ADMIN_INGAME_CONSOLE_PROXY_PREFIX = `${ADMIN_PREFIX}/ingame-console/proxy/env`; // ingame console 代理api
export const GAUTH_PROXY_PREFIX = `${API_PREFIX}/gauth-center/proxy/api`; // gauth 代理api

export const PROJECT_SRV = '/nextgamedev.ProjectSrv'; // auto-table配置项目
export const BILLING_PREFIX = `${API_PREFIX}/fee-center`;
export const BILLING_PROXY_VIEW = `${API_PREFIX}/fee-center/proxy/view`; // 费用中心代理的view-api
export const BILLING_PROXY_EDIT = `${API_PREFIX}/fee-center/proxy/edit`; // 费用中心代理的edit-api
export const ADMIN_BILLING_PROXY_VIEW = `${ADMIN_PREFIX}/fee-center/proxy/view`; // 费用中心admin权限代理的api
export const ADMIN_BILLING_PROXY = `${ADMIN_PREFIX}/fee-center/proxy`; // 费用中心admin权限代理的api

export const ADMIN_RBAC_SUPPORT = `${ADMIN_PREFIX}/rbac-support`; // 权限中心admin权限代理的api
export const ADMIN_RBAC_PROXY = `${ADMIN_RBAC_SUPPORT}/proxy/ingame.OpenApiSrv`; // 权限中心admin权限代理的api
export const ADMIN_GCLOUD_PROXY = `${ADMIN_PREFIX}/gcloud/open/proxy/api`; // GCloud admin权限代理的api
export const ADMIN_SUPPORT_USER = `${ADMIN_PREFIX}/support-user`;
export const ADMIN_PROXY_HYBRID = `${API_PREFIX}/admin-proxy-hybrid`;
